export enum PersonRelationEnum {
  SELF = 'self',
  SPOUSE = 'spouse',
  DEPENDENT = 'dependent',
}
